import { Component, OnInit } from '@angular/core';
import { IReportData, IReportMetadata, IReportResponse, ReportDataService } from '../../../shared/report/report-data.service';
import { IObject } from '../../../../type_definitions/datatypes';
import * as _ from 'underscore';
import { BrowseListConfigService, IBrowseListConfig } from '../../../shared/browselists/browselists-config.service';

@Component({
  selector: 'embedded-report-demo',
  template: `
    <ng-container *ngIf="true">
      <h4>Embedded Report</h4>
      <button class="btn btn-primary col-space-bottom" (click)="loadData()"><i class="fa fa-refresh"></i> Refresh Data</button>
      <br/><br/>  
    </ng-container>
    <embedded-report
      [sectionId]="sectionId"
      [browselistConfig]="browselistConfig"
      [reportMetadata]="reportMetadata"
      [reportDataLoading]="loading"
      [reportData]="reportData"
      [browselistContext]="ga3FormContext"
      [queryFilters]="queryFilters"
      [showActions]="true"
      [showOperations]="true">
    </embedded-report>
  `
})
export class EmbeddedReportDemoComponent implements OnInit {
  public sectionId: string = '1';
  public reportId: number;
  public reportMetadata: IReportMetadata;
  public loading: boolean = false;
  public reportData: IReportData;

  public queryFilters: IObject = {
    Cucomid: 1571,
    Ordertotalstable: 'ordertotals_calculated_all'
  };
  public ga3FormContext: IObject = {
    TEST: 1,
    TEST2: 2
  };
  public browselistConfig: IBrowseListConfig;

  constructor(
    public reportDataService: ReportDataService,
    browselistConfigService: BrowseListConfigService
  ) {
    this.browselistConfig = browselistConfigService.getConfig('ORDER_EDIT');
    this.reportId = this.browselistConfig?.reportId;
  }

  public ngOnInit(): void {
    this.reportDataService.loadMetaData(this.reportId)
      .then((res) => {
        this.reportMetadata = _.clone(res);

        // load data immediately
        this.loadData();
      });
  }

  public loadData(): void {
    this.loading = true;
    this.reportDataService.loadData(this.sectionId, this.reportId, this.queryFilters)
      .then((reportData: IReportResponse) => {
        this.reportData = _.clone(reportData?.data);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}